import { render, staticRenderFns } from "./BrickSettingsJourney.vue?vue&type=template&id=7427d02e&"
import script from "./BrickSettingsJourney.vue?vue&type=script&lang=js&"
export * from "./BrickSettingsJourney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7427d02e')) {
      api.createRecord('7427d02e', component.options)
    } else {
      api.reload('7427d02e', component.options)
    }
    module.hot.accept("./BrickSettingsJourney.vue?vue&type=template&id=7427d02e&", function () {
      api.rerender('7427d02e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Journey/BrickSettingsJourney.vue"
export default component.exports